import type { Episode } from "@/types/content";

export const episodes: Episode[] = [
  {
    id: "e1",
    number: 1,
    title: "走进姜家大门",
    season: 1,
    year: 2018,
    airDate: "2018-03-12",
    summary: "一场低调的家族婚礼，让身份神秘的尹瑟琪正式走入姜家，也让盘踞多年的家族格局悄然松动。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20melodrama%20still%20of%20an%20elegant%20woman%20in%20a%20navy%20dress%20walking%20into%20a%20grand%20mansion%20hall%2C%20guests%20watching%20in%20silence%2C%20moody%20low-key%20lighting%2C%20deep%20blue%20and%20gold%20tones%2C%20film%20grain&width=800&height=450&seq=ep-cover-01&orientation=landscape",
    characterIds: ["c1", "c4", "c2"],
    sections: [
      {
        heading: "低调的婚礼",
        text: "姜泰镇会长不顾众人反对，迎娶了比自己小二十余岁的尹瑟琪。婚礼简朴却暗流涌动，姜家上下各怀心思，唯有小女儿恩星送上了真心的祝福。",
      },
      {
        heading: "第一眼的敌意",
        text: "志勋在婚礼上第一次见到继母，冷淡而疏离。他当众提及母亲，给足了对方难堪，也让瑟琪清楚意识到，这座宅子远比想象中更需要步步为营。",
      },
    ],
  },
  {
    id: "e2",
    number: 2,
    title: "深夜的试探",
    season: 1,
    year: 2018,
    airDate: "2018-03-19",
    summary: "为查清瑟琪来历，志勋暗中调取资料；而一场深夜的家宴，让两人的较量正式拉开序幕。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20melodrama%20still%20of%20a%20tense%20dinner%20table%20scene%20in%20a%20dim%20luxury%20dining%20room%2C%20man%20and%20woman%20exchanging%20cold%20glances%2C%20warm%20candlelight%20against%20dark%20blue%20shadows%2C%20film%20grain&width=800&height=450&seq=ep-cover-02&orientation=landscape",
    characterIds: ["c2", "c1", "c6"],
    sections: [
      {
        heading: "一份来历不明的档案",
        text: "志勋委托的调查陷入僵局，瑟琪的过去像被人刻意抹去。越是查不到，他越确信这个女人藏着秘密。",
      },
      {
        heading: "恩星的善意",
        text: "恩星主动接近瑟琪，带她熟悉宅子。两个女人间不经意的亲近，成为这座冰冷宅邸里少有的暖色。",
      },
    ],
  },
  {
    id: "e3",
    number: 3,
    title: "理事会的暗流",
    season: 1,
    year: 2018,
    airDate: "2018-03-26",
    summary: "白婉婷在理事会上公开质疑瑟琪插手集团事务，一场关于权力与尊严的交锋在会议桌上展开。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20melodrama%20still%20of%20a%20tense%20boardroom%20meeting%20with%20a%20long%20table%2C%20a%20woman%20standing%20assertively%2C%20others%20seated%20in%20silence%2C%20cool%20grey-blue%20lighting%20through%20glass%20walls%2C%20film%20grain&width=800&height=450&seq=ep-cover-03&orientation=landscape",
    characterIds: ["c3", "c1", "c4"],
    sections: [
      {
        heading: "当众发难",
        text: "婉婷以\"外人\"为由，质疑瑟琪出席理事会的资格。瑟琪不卑不亢，用一份缜密的市场分析回敬，让在场理事刮目相看。",
      },
      {
        heading: "会长的态度",
        text: "泰镇始终未表态，散会后却将一份关键文件交给瑟琪保管。这份信任，成了婉婷心中最深的刺。",
      },
    ],
  },
  {
    id: "e4",
    number: 4,
    title: "失控的雨夜",
    season: 1,
    year: 2018,
    airDate: "2018-04-02",
    summary: "一场暴雨中，志勋的车在郊外抛锚，恰好路过的瑟琪选择停下。这个夜晚改变了两人之间的一切。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20melodrama%20still%20of%20two%20people%20sheltering%20under%20a%20rain-soaked%20overpass%20at%20night%2C%20neon%20reflections%20on%20wet%20asphalt%2C%20cool%20blue%20tones%20with%20warm%20streetlight%2C%20film%20grain&width=800&height=450&seq=ep-cover-04&orientation=landscape",
    characterIds: ["c1", "c2", "c7"],
    sections: [
      {
        heading: "顺路的一程",
        text: "瑟琪没有多问，只是把伞递过去。车里长时间的沉默里，志勋第一次没有用敌意去回应她。",
      },
      {
        heading: "崔律师的提醒",
        text: "崔律师劝瑟琪尽早抽身，\"姜家是口深井\"。瑟琪却只是笑笑，说她有必须留下的理由。",
      },
    ],
  },
  {
    id: "e5",
    number: 5,
    title: "旧案疑云",
    season: 1,
    year: 2018,
    airDate: "2018-04-09",
    summary: "记者徐慧珍追查一桩十余年前的旧案，线索竟意外指向姜家，也指向瑟琪的真实身份。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20melodrama%20still%20of%20a%20female%20journalist%20studying%20old%20documents%20under%20a%20desk%20lamp%20in%20a%20dim%20office%20at%20night%2C%20scattered%20papers%20and%20photos%2C%20warm%20lamp%20against%20dark%20background%2C%20film%20grain&width=800&height=450&seq=ep-cover-05&orientation=landscape",
    characterIds: ["c5", "c1", "c2"],
    sections: [
      {
        heading: "一份泛黄的报纸",
        text: "慧珍在档案室里找到一则当年被迅速压下的新闻，死者名字与瑟琪的家人有关。",
      },
      {
        heading: "两个女人的对视",
        text: "瑟琪意外与慧珍相遇，一眼便认出对方在查什么。她没有阻止，只说了一句：\"真相迟早要见光。\"",
      },
    ],
  },
  {
    id: "e6",
    number: 6,
    title: "病榻上的托付",
    season: 1,
    year: 2018,
    airDate: "2018-04-16",
    summary: "泰镇病情突然恶化，在病榻上做出惊人的人事安排，全剧格局由此迎来第一个转折。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20melodrama%20still%20of%20a%20hospital%20room%20at%20dusk%2C%20an%20elderly%20ill%20man%20holding%20a%20womans%20hand%2C%20soft%20window%20light%2C%20muted%20cool%20tones%20with%20warm%20accents%2C%20emotional%20tone%2C%20film%20grain&width=800&height=450&seq=ep-cover-06&orientation=landscape",
    characterIds: ["c4", "c1", "c2"],
    sections: [
      {
        heading: "最后的嘱托",
        text: "泰镇将一份密封文件郑重交给瑟琪，并叮嘱志勋要相信她。父亲的这句话，成了志勋心中最大的疑问。",
      },
      {
        heading: "各方的动作",
        text: "消息走漏后，婉婷连夜召集心腹。所有人都意识到，姜家真正的风暴才刚刚开始。",
      },
    ],
  },
  {
    id: "e7",
    number: 7,
    title: "账目里的破绽",
    season: 2,
    year: 2019,
    airDate: "2019-05-07",
    summary: "第二季开篇，婉婷经手的子公司账目出现巨大窟窿，她将矛头巧妙引向瑟琪。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20melodrama%20still%20of%20a%20woman%20scrutinizing%20financial%20ledgers%20spread%20across%20a%20dark%20mahogany%20desk%2C%20harsh%20desk%20lamp%20light%2C%20cool%20high-contrast%20shadow%2C%20film%20grain&width=800&height=450&seq=ep-cover-07&orientation=landscape",
    characterIds: ["c3", "c1", "c7"],
    sections: [
      {
        heading: "被伪造的签名",
        text: "一份带有瑟琪签名的转账凭证出现在审计报告中。瑟琪一眼看出笔迹端倪，却选择按兵不动。",
      },
      {
        heading: "崔律师的布局",
        text: "崔律师暗中比对档案，悄悄保留了关键证据，等待最合适的时机。",
      },
    ],
  },
  {
    id: "e8",
    number: 8,
    title: "妹妹的发现",
    season: 2,
    year: 2019,
    airDate: "2019-05-14",
    summary: "恩星在无意中撞见婉婷与外人密会，一份秘密协议的复印件由此流出。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20melodrama%20still%20of%20a%20young%20woman%20hiding%20behind%20a%20corridor%20corner%20holding%20a%20document%2C%20two%20figures%20whispering%20in%20the%20distance%2C%20dim%20mansion%20interior%2C%20tense%20cool%20lighting%2C%20film%20grain&width=800&height=450&seq=ep-cover-08&orientation=landscape",
    characterIds: ["c6", "c3", "c1"],
    sections: [
      {
        heading: "走廊尽头的低语",
        text: "恩星本只是想给瑟琪送花，却在转角听见了不该听的话。她慌乱逃走，手里的文件却落在了原地。",
      },
      {
        heading: "瑟琪的选择",
        text: "瑟琪拿到文件，却没有立刻公开。她明白，仅凭这一纸凭证，还不足以撼动婉婷。",
      },
    ],
  },
  {
    id: "e9",
    number: 9,
    title: "报道之外",
    season: 2,
    year: 2019,
    airDate: "2019-05-21",
    summary: "慧珍的深度报道引爆舆论，姜氏股价震荡，志勋却在字里行间读出了另一层真相。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20melodrama%20still%20of%20a%20newspaper%20front%20page%20and%20a%20phone%20lighting%20up%20on%20a%20dark%20desk%20at%20night%2C%20cold%20blue%20tone%2C%20a%20hand%20resting%20nearby%2C%20film%20grain&width=800&height=450&seq=ep-cover-09&orientation=landscape",
    characterIds: ["c5", "c2", "c1"],
    sections: [
      {
        heading: "头版头条",
        text: "报道直指姜氏内部治理问题，措辞克制却刀刀见骨。慧珍坚持只写证据能支撑的部分。",
      },
      {
        heading: "被刺痛的信任",
        text: "志勋质问慧珍，两人多年的信任出现裂痕。而更让他不安的，是报道里那句\"有人早已知道真相\"。",
      },
    ],
  },
  {
    id: "e10",
    number: 10,
    title: "危险的同盟",
    season: 2,
    year: 2019,
    airDate: "2019-05-28",
    summary: "婉婷主动接触郑泰成，两家宿敌因利益结成脆弱的同盟，一场更大的吞并计划正在酝酿。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20melodrama%20still%20of%20two%20businesspeople%20shaking%20hands%20in%20a%20dim%20glass-walled%20office%20at%20night%2C%20city%20lights%20outside%2C%20cold%20teal%20and%20dark%20tones%2C%20film%20grain&width=800&height=450&seq=ep-cover-10&orientation=landscape",
    characterIds: ["c3", "c8", "c7"],
    sections: [
      {
        heading: "各怀鬼胎的握手",
        text: "婉婷需要资金与外部背书，郑泰成需要姜氏的渠道。两人举杯，笑意却都没到眼底。",
      },
      {
        heading: "崔律师的警觉",
        text: "一场饭局的时间与地点巧合，让崔律师嗅到了危险的气息，他决定加快手上的准备。",
      },
    ],
  },
  {
    id: "e11",
    number: 11,
    title: "遗嘱的真相",
    season: 2,
    year: 2019,
    airDate: "2019-06-04",
    summary: "密封文件终于启封，其中的内容颠覆了所有人的预想，也让瑟琪的处境变得异常艰难。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20melodrama%20still%20of%20a%20sealed%20envelope%20being%20opened%20on%20a%20long%20table%20surrounded%20by%20silent%20figures%2C%20dramatic%20overhead%20light%2C%20deep%20shadows%2C%20deep%20blue%20and%20gold%20accents%2C%20film%20grain&width=800&height=450&seq=ep-cover-11&orientation=landscape",
    characterIds: ["c7", "c1", "c4"],
    sections: [
      {
        heading: "出人意料的安排",
        text: "泰镇将集团治理权与家族信托的监督权一并交由瑟琪暂代。这份信任之重，超出所有人的想象。",
      },
      {
        heading: "处境反转",
        text: "一夜之间，瑟琪从\"外人\"变成众矢之的。她站在风口浪尖，却比任何时候都冷静。",
      },
    ],
  },
  {
    id: "e12",
    number: 12,
    title: "站在她这一边",
    season: 2,
    year: 2019,
    airDate: "2019-06-11",
    summary: "志勋第一次在家族会议上公开站在瑟琪身旁，两人关系迎来重要转折。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20melodrama%20still%20of%20a%20man%20and%20woman%20standing%20shoulder%20to%20shoulder%20in%20a%20tense%20meeting%20room%20facing%20a%20hostile%20crowd%2C%20backlit%20dramatic%20lighting%2C%20deep%20blue%20tones%2C%20film%20grain&width=800&height=450&seq=ep-cover-12&orientation=landscape",
    characterIds: ["c2", "c1", "c3"],
    sections: [
      {
        heading: "一句\"我信她\"",
        text: "面对婉婷的连环发难，志勋打断了争执，只说了一句：\"这件事，我站她这边。\"满室哗然。",
      },
      {
        heading: "墙外的沉默",
        text: "散会后，瑟琪问志勋为什么，他只是别过头。有些答案，谁都没准备好说出口。",
      },
    ],
  },
  {
    id: "e13",
    number: 13,
    title: "越界的界线",
    season: 3,
    year: 2020,
    airDate: "2020-06-02",
    summary: "第三季开篇，两人的默契与情感都越过了那条不该越过的线，谁都装作若无其事。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20melodrama%20still%20of%20a%20man%20and%20woman%20standing%20apart%20on%20a%20rooftop%20balcony%20at%20twilight%2C%20city%20skyline%20beyond%2C%20restrained%20emotion%2C%20muted%20purple-blue%20dusk%20tones%2C%20film%20grain&width=800&height=450&seq=ep-cover-13&orientation=landscape",
    characterIds: ["c1", "c2", "c5"],
    sections: [
      {
        heading: "天台上的沉默",
        text: "应酬结束后，两人在露台吹风。瑟琪退后一步，志勋却先开口：\"别再把我当外人。\"",
      },
      {
        heading: "慧珍的追问",
        text: "慧珍察觉了志勋的变化，她没有说破，只提醒他：\"有些线一旦越过，就回不去了。\"",
      },
    ],
  },
  {
    id: "e14",
    number: 14,
    title: "被拿走的证物",
    season: 3,
    year: 2020,
    airDate: "2020-06-09",
    summary: "婉婷抢先一步销毁了关键证物，并反咬恩星\"伪造文件\"，局面急转直下。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20melodrama%20still%20of%20an%20empty%20open%20safe%20in%20a%20dim%20study%2C%20a%20shocked%20young%20woman%20staring%20at%20it%2C%20harsh%20cold%20lighting%2C%20deep%20shadows%2C%20film%20grain&width=800&height=450&seq=ep-cover-14&orientation=landscape",
    characterIds: ["c3", "c6", "c8"],
    sections: [
      {
        heading: "空了的保险柜",
        text: "恩星带人前来取证，保险柜却已被清空。婉婷当场反咬，指控恩星造假。",
      },
      {
        heading: "瑟琪的底牌",
        text: "瑟琪安抚住慌乱的恩星，她轻声说：\"我们还有一份，谁也想不到的。\"",
      },
    ],
  },
  {
    id: "e15",
    number: 15,
    title: "反水的前夜",
    season: 3,
    year: 2020,
    airDate: "2020-06-16",
    summary: "郑泰成在吞并计划的最后一步选择了反水，婉婷的同盟瞬间崩塌。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20melodrama%20still%20of%20a%20man%20leaving%20a%20glass%20office%20tower%20at%20night%20while%20a%20woman%20watches%20in%20shock%20through%20the%20window%2C%20cold%20blue%20city%20lights%2C%20film%20grain&width=800&height=450&seq=ep-cover-15&orientation=landscape",
    characterIds: ["c8", "c3", "c4"],
    sections: [
      {
        heading: "临走前的一通电话",
        text: "郑泰成在登机前拨通了瑟琪的号码，只说：\"姜会长欠我的人情，今天还了。\"",
      },
      {
        heading: "崩塌的多米诺",
        text: "失去外援的婉婷资金链断裂，董事会中原本观望的人纷纷倒戈，她的帝国一夜之间摇摇欲坠。",
      },
    ],
  },
  {
    id: "e16",
    number: 16,
    title: "旧案重见天日",
    season: 3,
    year: 2020,
    airDate: "2020-06-23",
    summary: "崔律师公开多年前被掩埋的档案，瑟琪母亲的冤屈终于真相大白。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20melodrama%20still%20of%20a%20press%20conference%20under%20harsh%20camera%20flashes%2C%20a%20calm%20woman%20at%20a%20podium%20holding%20documents%2C%20crowd%20of%20reporters%2C%20cool%20high-contrast%20lighting%2C%20film%20grain&width=800&height=450&seq=ep-cover-16&orientation=landscape",
    characterIds: ["c1", "c7", "c3"],
    sections: [
      {
        heading: "泛黄档案前的鞠躬",
        text: "瑟琪在发布会上深深鞠躬，为母亲，也为这十年忍辱的沉默。全场闪光灯不停。",
      },
      {
        heading: "落幕的序幕",
        text: "真相既出，婉婷再无退路。但瑟琪清楚，赢得公道之后，她与志勋之间还有更难的题要解。",
      },
    ],
  },
  {
    id: "e17",
    number: 17,
    title: "说出那句话",
    season: 3,
    year: 2020,
    airDate: "2020-06-30",
    summary: "尘埃落定后，志勋终于说出藏在心里的话，而瑟琪给出了自己的答案。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20melodrama%20still%20of%20a%20quiet%20emotional%20conversation%20between%20a%20man%20and%20a%20woman%20in%20a%20snowy%20courtyard%20at%20dusk%2C%20soft%20falling%20snow%2C%20muted%20cool%20tones%20with%20warm%20lamp%20glow%2C%20film%20grain&width=800&height=450&seq=ep-cover-17&orientation=landscape",
    characterIds: ["c2", "c1", "c6"],
    sections: [
      {
        heading: "雪夜的表白",
        text: "志勋在庭院等到深夜，把那些绕了很多年的话说了出来。瑟琪没有立刻回答，只是红了眼眶。",
      },
      {
        heading: "她的答案",
        text: "\"我等这一天，也等了很久。\"瑟琪说。有些感情，迟到了，却终究没有缺席。",
      },
    ],
  },
  {
    id: "e18",
    number: 18,
    title: "新的家门",
    season: 3,
    year: 2020,
    airDate: "2020-07-07",
    summary: "大结局。姜家进入新的时代，瑟琪与志勋并肩而立，为这段恩怨画上句点。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20melodrama%20still%20of%20a%20sunlit%20mansion%20gate%20opening%20at%20dawn%2C%20two%20figures%20walking%20through%20together%2C%20warm%20hopeful%20morning%20light%2C%20golden%20and%20soft%20blue%20tones%2C%20film%20grain&width=800&height=450&seq=ep-cover-18&orientation=landscape",
    characterIds: ["c1", "c2", "c3", "c6"],
    sections: [
      {
        heading: "账清了，人也散了",
        text: "婉婷交出全部股权离场。离去的背影里，没有被原谅，只有各自的选择与代价。",
      },
      {
        heading: "门里的新光",
        text: "瑟琪站在姜家大门前，第一次觉得自己真正属于这里。志勋握住她的手，两人一起走进晨光里。",
      },
    ],
  },
];